const _temp0 = require("./0.jpg");
const _temp1 = require("./1.jpg");
const _temp2 = require("./2.jpg");
const _temp3 = require("./3.jpg");
const _temp4 = require("./auki.jpg");
const _temp5 = require("./kiinni.jpg");
const _temp6 = require("./opened.jpg");
const _temp7 = require("./valoton.jpg");
module.exports = {
  "0": _temp0,
  "1": _temp1,
  "2": _temp2,
  "3": _temp3,
  "auki": _temp4,
  "kiinni": _temp5,
  "opened": _temp6,
  "valoton": _temp7
}